import { FlowChartContentRespontents } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentRespontents'

export class FlowChartContentRespontentsBuilder {
  private count = 0
  private contentId: number | undefined

  constructor(count: number) {
    this.count = count
  }

  public withContentId(contentId: number | undefined): FlowChartContentRespontentsBuilder {
    this.contentId = contentId
    return this
  }

  public build(): FlowChartContentRespontents {
    return {
      count: this.count,
      contentId: this.contentId,
    }
  }
}
